<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <h1 class="md-title">Monitoreo</h1>
        <md-button class="md-icon-button md-primary" @click="changeMetric(-1)" style="margin-top: -5px;">
            <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <md-button class="md-icon-button md-primary" @click="changeMetric(1)" style="margin-top: -5px;">
            <md-icon>keyboard_arrow_right</md-icon>
        </md-button>
        <span class="md-title">{{selectedMetricData.name}}</span>

        <div class="md-layout">
            <div class="md-layout-item">
                <span class="md-title">Total Histórico</span>
                <br />
                <span class="md-display-4">{{getValue(selectedMetric, 'total', 'total')}}</span>
            </div>
            <div class="md-layout-item">
                <span class="md-title">Progreso del Día</span>
                <br />
                <BarChart v-bind:data="selectedMetricData.hourTodayTotal.data" 
                          v-bind:labels="selectedMetricData.hourTodayTotal.labels"
                          v-bind:tooltip="selectedMetricData.name"
                          :height="300"/>
            </div>
            <div class="md-layout-item">
                <span class="md-title">Comparación de Días</span>
                <br />
                <BarChart v-bind:data="selectedMetricData.dayComparison.data" 
                          v-bind:labels="selectedMetricData.dayComparison.labels"
                          v-bind:tooltip="selectedMetricData.name"
                          :height="300"/>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item">
                <span class="md-title">Total por día de la semana</span>
                <br />
                <BarChart v-bind:data="selectedMetricData.weekday.data" 
                          v-bind:labels="selectedMetricData.weekday.labels"
                          v-bind:tooltip="selectedMetricData.name"
                          :height="300"/>        
            </div>
            <div class="md-layout-item">
                <span class="md-title">Promedio por día del mes</span>
                <br />
                <LineChart v-bind:data="selectedMetricData.monthdayAverage.data" 
                          v-bind:labels="selectedMetricData.monthdayAverage.labels"
                          v-bind:tooltip="selectedMetricData.name"
                          :height="300"/>
            </div>
            <div class="md-layout-item">
                <span class="md-title">Promedio por hora del día</span>
                <br />
                <LineChart v-bind:data="selectedMetricData.hourAverage.data" 
                          v-bind:labels="selectedMetricData.hourAverage.labels"
                          v-bind:tooltip="selectedMetricData.name"
                          :height="300"/>
            </div>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  @import "~vue-material/src/theme/engine";

  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-layout-item {
    margin: 30px;
    text-align: center;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig';
import {user} from '../helpers/user';
import axios from "axios";
import BarChart from './BarChart.vue';
import LineChart from './LineChart.vue';


export default {
    name: 'Dashboard',
    components: {
        Header, Menu, BarChart, LineChart
    },
    data: () => ({
        menuVisible: false,
        eventStats: {},
        selectedMetric: 'APP_OPEN',
        selectedMetricData: {
            name: ''
        },
        metricIndex: 0
    }),
    watch: {
        '$route': 'fetchData'
    },
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
        if (liuser) {
            console.log('User logged in, go ahead...');
            var that = this;
            user.init(firebase.auth().currentUser, () => {
                that.fetchData();
            });
        } else {
            this.$router.push('/auth')
            console.log('User not logged in!');
        }
        });
    },
    methods: {
        toggleMenu: function () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/eventStats", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.eventStats = result.data;
                    this.selectMetric(this.selectedMetric);
                    this.getEventTypeByPosition(1);
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        changeMetric (dir) {
            this.metricIndex = this.metricIndex + dir;
            var metricCount = Object.keys(this.getEventTypes()).length;
            if (this.metricIndex < 0) {
                this.metricIndex = (metricCount - 1);
            }
            if (this.metricIndex > (metricCount - 1)) {
                this.metricIndex = 0;
            }
            this.selectedMetric = this.getEventTypeByPosition(this.metricIndex);
            this.selectMetric(this.selectedMetric);
        },
        selectMetric (metric) {
            var d = new Date();
            var today = d.toISOString().substr(0, 11);

            console.log(metric);

            this.selectedMetricData = {
                name: this.eventName(metric),
                dayComparison: {
                    labels: ['-30 días', '-7 días', 'Ayer', 'Hoy'],
                    data: [
                        this.getValue(metric, 'daily', 'day', '@lastmonthday', 'total'),
                        this.getValue(metric, 'daily', 'day', '@lastweekday', 'total'),
                        this.getValue(metric, 'daily', 'day', '@yesterday', 'total'),
                        this.getValue(metric, 'daily', 'day', '@today', 'total')
                    ]
                },
                weekday: {
                    labels: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb'],
                    data: [
                        this.getValue(metric, 'daily', 'week-day', 'W-0', 'total'),
                        this.getValue(metric, 'daily', 'week-day', 'W-1', 'total'),
                        this.getValue(metric, 'daily', 'week-day', 'W-2', 'total'),
                        this.getValue(metric, 'daily', 'week-day', 'W-3', 'total'),
                        this.getValue(metric, 'daily', 'week-day', 'W-4', 'total'),
                        this.getValue(metric, 'daily', 'week-day', 'W-5', 'total'),
                        this.getValue(metric, 'daily', 'week-day', 'W-6', 'total')
                    ]
                },
                monthdayAverage: {
                    labels: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
                    data: [
                        this.getValue(metric, 'daily', 'month-day', 'D-1', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-2', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-3', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-4', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-5', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-6', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-7', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-8', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-9', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-10', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-11', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-12', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-13', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-14', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-15', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-16', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-17', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-18', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-19', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-20', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-21', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-22', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-23', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-24', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-25', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-26', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-27', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-28', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-29', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-30', 'avg'),
                        this.getValue(metric, 'daily', 'month-day', 'D-31', 'avg'),
                    ]
                },
                hourAverage: {
                    labels: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                    data: [
                        this.getValue(metric, 'hourly', 'hour', 'H-0', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-1', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-2', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-3', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-4', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-5', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-6', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-7', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-8', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-9', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-10', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-11', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-12', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-13', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-14', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-15', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-16', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-17', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-18', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-19', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-20', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-21', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-22', 'avg'),
                        this.getValue(metric, 'hourly', 'hour', 'H-23', 'avg')
                    ]
                },
                hourTodayTotal: {
                    labels: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                    data: [
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'00', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'01', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'02', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'03', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'04', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'05', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'06', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'07', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'08', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'09', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'10', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'11', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'12', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'13', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'14', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'15', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'16', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'17', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'18', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'19', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'20', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'21', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'22', 'total'),
                        this.getValue(metric, 'hourly', 'day-hour', 'DH-'+today+'23', 'total')
                    ]
                }
            }
        },
        getValue (event, granularity, accumulator, item, value) {
            var res = 0;

            if (item == '@today') {
                var d = new Date();
                item = 'DD-' + d.toISOString().substr(0, 10);
                console.log(item);
            }
            if (item == '@yesterday') {
                var d = new Date();
                d.setDate(d.getDate() - 1);
                item = 'DD-' + d.toISOString().substr(0, 10);
                console.log(item);
            }
            if (item == '@lastweekday') {
                var d = new Date();
                d.setDate(d.getDate() - 7);
                item = 'DD-' + d.toISOString().substr(0, 10);
                console.log(item);
            }
            if (item == '@lastmonthday') {
                var d = new Date();
                d.setMonth(d.getMonth() - 1);
                item = 'DD-' + d.toISOString().substr(0, 10);
                console.log(item);
            }

            if (!this.eventStats[event]) {
                return res;
            }
            if (!this.eventStats[event][granularity]) {
                return res;
            }
            if (!this.eventStats[event][granularity][accumulator]) {
                return res;
            }
            if (!this.eventStats[event][granularity][accumulator][item]) {
                if (!item) {
                    return this.eventStats[event][granularity][accumulator];
                } else {
                    return res;
                }
            }
            if (!this.eventStats[event][granularity][accumulator][item][value]) {
                if (!value) {
                    return this.eventStats[event][granularity][accumulator][item];
                } else {
                    return res;
                }
            }

            return this.eventStats[event][granularity][accumulator][item][value];
        },
        eventName (label) {
            var n = this.getEventTypes();
            return (n[label]) ? n[label] : label;
        },
        getEventTypeByPosition (pos) {
            var n = this.getEventTypes();
            var k = Object.keys(n);
            return k[pos];
        },
        getEventTypes () {
            return {
                'APP_OPEN': 'Inicio de Aplicación',
                'LOGIN_AUTO_OK': 'Ingreso de jugador automático (OK)',
                'LOGIN_AUTO_ERROR': 'Ingreso de jugador automático (ERROR)',
                'LOGIN_MANUAL_OK': 'Ingreso de jugador manual (OK)',
                'LOGIN_MANUAL_ERROR': 'Ingreso de jugador manual (ERROR)',
                'LOGIN_GOOGLE_OK': 'Ingreso de jugador con datos de Google (OK)',
                'LOGIN_GOOGLE_ERROR': 'Ingreso de jugador con datos de Google (ERROR)',
                'LOGIN_GOOGLE_NOEMAIL': 'Ingreso de jugador con datos de Google (Email no verificado)',
                'LOGIN_GOOGLE_PLAYER_CREATE_OK': 'Registro de usuario con datos de Google (OK)',
                'LOGIN_GOOGLE_PLAYER_CREATE_ERROR': 'Registro de usuario con datos de Google (ERROR)',
                'LOGIN_FB_OK': 'Ingreso de jugador con datos de Facebook (OK)',
                'LOGIN_FB_ERROR': 'Ingreso de jugador con datos de Facebook (ERROR)',
                'LOGIN_FB_NOEMAIL': 'Ingreso de jugador con datos de Facebook (Email no verificado)',
                'LOGIN_FB_PLAYER_CREATE_OK': 'Registro de usuario con datos de Facebook (OK)',
                'LOGIN_FB_PLAYER_CREATE_ERROR': 'Registro de usuario con datos de Facebook (ERROR)',
                'LOGIN_VERIFICATION_SENT_OK': 'Envío de email de verificación (OK)',
                'LOGIN_VERIFICATION_SENT_ERROR': 'Envío de email de verificación (ERROROK)',
                'LOGOUT_OK': 'Desconexión (OK)',
                'CHANGEPASS_OK': 'Cambio de clave (OK)',
                'CHANGEPASS_ERROR': 'Cambio de clave (ERROR)',
                'RESETPASS_OK': 'Regeneración de clave (OK)',
                'RESETPASS_ERROR': 'Regeneración de clave (ERROR)',
                'REGISTER_OK': 'Registro de usuario (OK)',
                'REGISTER_ERROR': 'Registro de usuario (ERROR)',
                'GAME_START': 'Inicio de juego',
                'ANSWER_OK': 'Respuesta CORRECTA',
                'ANSWER_ERROR': 'Respuesta INCORRECTA',
                'GAME_END': 'Final de juego'
            };
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue